<template>
  <div class="admin-records">
    <teleport to="#modals">
      <modal v-if="toggleModal">Deleting...</modal>
    </teleport>
    <div>
      <ul>
        <li :class="{mobile: mobile}">
          <p>{{ record.title }}</p>
          <a
            :href="record.URL"
            target="_blank">get
            <ArrowNarrowDownIcon
              class="icon"
            />
          </a>
          <TrashIcon
            class="icon"
            @click="deleteFile"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs } from '@vue/reactivity'
import { inject, onMounted } from '@vue/runtime-core'
import { TrashIcon, ArrowNarrowDownIcon } from '@heroicons/vue/outline'
import { db, deleteDoc, doc, ref, deleteObject, storage } from '@/firebase/config'
import Modal from './Modal.vue'

export default {
  components: { TrashIcon, ArrowNarrowDownIcon, Modal },
  props: ['record'],
  setup (props, context) {
    const currentUser = inject('currentUser')
    const responsive = reactive({
      mobile: false,
      windowWidth: null,
      toggleModal: false
    })
    const { mobile, windowWidth, toggleModal } = toRefs(responsive)
    // Create a reference to the file to delete
    const storedRef = ref(storage, `/schools/inspire-schools/${currentUser.state.role}/${currentUser.state.grade}/${props.record.title}`)
    // deleteRecord
    const deleteFile = async () => {
      toggleModal.value = true
      await deleteObject(storedRef)
      await deleteDoc(doc(db, '/schools/inspire-schools/' + currentUser.state.grade +
      '/uploads/' + currentUser.state.role, props.record.id))
      toggleModal.value = false
      context.emit('deletion')
    }

    const handleview = () => {
      windowWidth.value = window.innerWidth
      if (windowWidth.value <= 750) {
        mobile.value = true
        return
      }
      mobile.value = false
    }

    onMounted(() => {
      handleview()
      window.addEventListener('resize', handleview)
    })

    return { mobile, deleteFile, currentUser, toggleModal }
  }
}
</script>

<style>
.admin-records {
  background: #fff;
}
.admin-records div {
  background: white;
  border: 1px solid pink;
  padding: 5px;
}
.admin-records li {
  list-style-type: none;
  background: #eee;
  color: #010;
  padding: 10px 20px;
  margin: 5px auto;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.admin-records li.mobile {
  display: flex;
  flex-direction: column;
}
.admin-records .icon {
  max-width: 17px;
  color: #010;
  cursor: pointer;
}
.admin-records p, h3, ul {
    padding: 0;
    margin: 0;
}
</style>
